import { useNotifications } from '@/stores/notifications';

import { Notification } from './notification';

export function Notifications() {
  const { notifications, dismissNotification } = useNotifications();

  return (
    <div className="fixed top-0 inset-x-0 w-full z-(--z-notification) max-h-40 lg:inset-x-auto lg:right-0 lg:w-sm">
      {notifications.map(notification => (
        <Notification
          key={notification.id}
          notification={notification}
          onDismiss={dismissNotification}
        />
      ))}
    </div>
  );
}
